import React, { useState, useEffect, useRef } from "react";
import Header from "./header/header";
import Footer from "./Footer";
import { ClipLoader } from "react-spinners";
import "./Scholarship.css";
import PhoneInput from "react-phone-input-2";
import axios from "axios";
import { z, ZodType } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "../firebase";
import { useUsers } from "./Contexts/UsersContext";
import { baseUrl, GetToken } from "../App";

type FormData = {
  fullName: string;
  email: string;
  coverLetter: string;
  gender: string;
  linkedIn: string;
  course: string;
  coursePriceAffordability: number;
};

const Scholarship: React.FC = () => {
  const [ready, setReady] = useState(false);
  const {Users} = useUsers();
  const [inputphone, setInputphone] = useState("");
  const applySectionRef = useRef<HTMLDivElement>(null);
  const [gender, setGender] = useState("");
  const [inputName, setInputName] = useState("");
  const [inputCoverLetter, setInputCoverLetter] = useState("");
  const [inputLinkedIn, setInputLinkedIn] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [nophoneerror, setNophoneerror] = useState(true);
  const [inputCoursePriceAffordability, setInputCoursePriceAffordability] =
    useState<number>();
  const [course, setCourse] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [authUser, setAuthUser] = useState(false);

  let navigate = useNavigate();
  const location = useLocation();
  const handleApplyNowClick = () => {
    applySectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCoursePriceAffordabilityChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = parseInt(e.target.value, 10);
    if (value < 0 || value > 99) {
      setInputCoursePriceAffordability(0);
    } else {
      setInputCoursePriceAffordability(value);
    }
  };

  useEffect(() => {
    const currentDate = new Date();
    const endDate = new Date(2024, 7, 30);

    if (currentDate > endDate) {
      setIsButtonDisabled(true);
    }
  }, []);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        setAuthUser(false);
        navigate("/signin", { state: { from: location.pathname } });
        return;
      } else {
        if (localStorage.getItem("doyenifyacademytwitterUid")) {
          setAuthUser(true);
        } else if (user?.emailVerified === true) {
          setAuthUser(true);
        } else {
          setAuthUser(false);
          navigate("/signin", { state: { from: location.pathname } });
        }
      }
    });
  }, [authUser, navigate, location.pathname]);

  const nameRegex = /^[A-Za-z\s]+$/;
  const linkedInUrlPattern =
    /^https?:\/\/(www\.)?linkedin\.com\/(in|pub|profile)\/[A-z0-9_-]+\/?$/;

  const schema: ZodType<FormData> = z.object({
    fullName: z
      .string()
      .min(5, { message: "Fullname must be at least 5 characters long" })
      .max(30, { message: "Fullname must be at most 30 characters long" })
      .regex(nameRegex, {
        message: "Fullname must only contain alphabetic characters",
      }),
    email: z.string().email(),
    coverLetter: z
      .string()
      .min(5, { message: "Must be at least 20 characters long" })
      .max(250, { message: "Must not be more than 250 characters long" })
      .regex(nameRegex, {
        message: "Must only contain alphabetic characters",
      }),
    coursePriceAffordability: z
      .number({ invalid_type_error: "Please input a number" })
      .min(10, { message: "Must be at least 10%" })
      .max(99, { message: "Must not be greater than 99%" }),
    gender: z.string().refine((val) => val === "Male" || val === "Female", {
      message: "Gender is required",
    }),
    linkedIn: z
      .string()
      .url("Invalid URL format")
      .regex(linkedInUrlPattern, "Invalid LinkedIn profile URL"),
    course: z
      .string()
      .refine(
        (val) =>
          val === "DevOps" ||
          val === "HTML and CSS3 fundamentals" ||
          val === "Artificial Intelligence Fundamentals" ||
          val === "Graphics Design" ||
          val === "WEB DESIGN" ||
          val === "Network Security" ||
          val === "Digital Marketing" ||
          val === "Python" ||
          val === "Data Science" ||
          val === "Mastering JavaScript Essentials" ||
          val === "Business Intelligence" ||
          val === "C# for Beginners" ||
          val === "Automation Software Testing" ||
          val === "Financial Data Analytics" ||
          val === "Search Engine Optimization (SEO)" ||
          val === "UI/UX DESIGN" ||
          val === "IT Business Analysis" ||
          val === "Data Analytics" ||
          val === "Frontend Development" ||
          val === "Mastering Github Essentials" ||
          val === "Basics of SQL" ||
          val === "Elixir + Phoenix for Beginners" ||
          val === "Full-stack Web Development with Python and Django" ||
          val === "Full-stack Web Development with node" ||
          val === "Cybersecurity" ||
          val === "Data Engineering" ||
          val === "Manual Software Testing" ||
          val === "Mobile App Development" ||
          val === "Product Management",
        {
          message: "Select a course",
        }
      ),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>({ resolver: zodResolver(schema) });

  const submitScholAppForm = async (data: FormData) => {
    if (inputphone.length < 6) {
      setNophoneerror(false);
      return;
    }

    if (inputphone.length > 6) {
      setNophoneerror(true);

      try {

        const registeredUsers:any = Users;
        const emailExists = registeredUsers.some(
          (user: any) => user.email === data.email
        );

        if (!emailExists) {
          toast("Email is not registered. Please register your email first.");
          return;
        }

        // Check if any of the details have already been used for a scholarship request
        let idToken = await GetToken();
        const scholarshipResponse = await axios.get(
          `${baseUrl}/ScholAppForm`,
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          }
        );

        const scholarshipRequests = scholarshipResponse.data;
        const detailsExist = scholarshipRequests.some(
          (request: any) =>
            request.Email === data.email ||
            request.Name === data.fullName ||
            request.CoverLetter === data.coverLetter ||
            request.Linkedin === data.linkedIn ||
            request.Course === data.course
        );

        if (detailsExist) {
          toast("You have already requested a scholarship with these details.");
          return;
        }

        // Proceed with form submission
        const scholAppFormData = {
          Name: data.fullName.trim(),
          Email: data.email.trim(),
          Gender: data.gender.trim(),
          Phone: inputphone.trim(),
          CoverLetter: data.coverLetter.trim(),
          Linkedin: data.linkedIn.trim(),
          Course: data.course.trim(),
          AffordableAmount: data.coursePriceAffordability,
        };

        const bodytouser = {
          sender: {
            name: "DoyenifyAcademy",
            email: "scholarships@doyenify.com",
          },
          to: [
            {
              email: data.email,
            },
          ],
          replyTo:{
            email:"info.doyenify@gmail.com",
          },
          subject: "Confirmation: Request for scholarship",
          htmlContent: `<html><head>
                <style>
                    body {
                        background-color:#696969;
                    }
                    .imgtag{
                        justify-content: center;
                        align-items: center;
                        margin-left: 45%;
                    }
                    .welcome {
                        text-align: center;
                        color: #696969;
                    }
                    .content {
                        background-color: #ffffff;
                        margin: 15px;
                        padding: 20px;
                    }
                </style> 
            </head>
            <body>
                <div class="imgtag">
                    <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
                </div>
                
                <div class="content">
                    <p>Dear {{params.name}},</p> 
                    <p>Thank you for applying for the Doyenify Academy Scholarship Program. We are thrilled to see your interest in advancing your tech skills with us.</p>
                    <p>Our team is carefully reviewing all applications, and we are impressed with the passion and dedication shown by all candidates. We will announce the scholarship recipients on June 21.</p>
                    <p>We appreciate your patience and wish you the best of luck!</p>
                    <p>Best regards,</p>  
                    <p>The Doyenify Academy Team</p>
                </div> 
            </body>
            </html>`,
          params: {
            name: data.fullName,
          },
        };

        const bodytodoyen = {
          sender: {
            name: "DoyenifyAcademyNotification",
            email: "scholarships@doyenify.com",
          },
          to: [
            {
              email: "info.doyenify@gmail.com",
            },
          ],
          replyTo:{
            email:"info.doyenify@gmail.com",
          },
          subject: "Someone requested for scholarship",
          htmlContent: `<html><head></head><body>
                            <h1>You have a newly scholarship candidate</h1>
                            <p>Participant Name: {{params.name}}, requested</p>
                            <p>Participant Email: {{params.email}}</p>
                            <p>Participant Phone Number: {{params.phone}}</p>
                            <p>Participant Cover Letter: {{params.coverLetter}}</p>
                            <p>Participant LinkedIn: {{params.linkedIn}}</p>
                            <p>Participant Course: {{params.course}}</p>
                        </body></html>`,
          params: {
            name: data.fullName,
            email: data.email,
            phone: inputphone,
            coverLetter: data.coverLetter,
            linkedIn: data.linkedIn,
            course: data.course,
          },
        };

        try {
          await axios.post(
            `${baseUrl}/ScholAppForm`,
            scholAppFormData,
            {
              headers: {
                Authorization: `Bearer ${idToken}`,
              },
            }
          );


           const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
                process.env.REACT_APP_SERVICE_KEY, {
                method: "post",
                body: JSON.stringify({
                  email: process.env.REACT_APP_SERVICE_EMAIL,
                  password: process.env.REACT_APP_SERVICE_PASSWORD,
                  returnSecureToken: true,
                }),
                headers: {
                  "Content-Type": "application/json",
                },
              });
      
              const userToken = await responseToken.json();
              await axios
              .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytouser, {
                  headers: { Authorization: `Bearer ${userToken.idToken}` },
                }
              )
              .then()
              .catch(() => {
                console.log("(axios) an error occurred")
              });

              await axios
              .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytodoyen, {
                  headers: { Authorization: `Bearer ${userToken.idToken}` },
                }
              )
              .then()
              .catch(() => {
                console.log("(axios) an error occurred")
              });
          
          setInputName("");
          setInputEmail("");
          setInputphone("234");
          setInputCoverLetter("");
          setGender("");
          setInputLinkedIn("");
          setCourse("");
          setInputCoursePriceAffordability(0);
          reset();
          toast("Scholarship successfully requested");
        } catch (error) {
          toast("Something went wrong, check your network");
          console.log(error);
        }
      } catch (error) {
        toast("Error checking registration status");
        console.log(error);
      }
    }
  };

  const loadings = () => {
    new Promise((r) => setTimeout(r, 205));
    setReady(true);
  };

  useEffect(() => {
    loadings();
  });

  return (
    <div>
      {ready ? (
        <>
          <Header />

          <br />
          <br />
          <ToastContainer autoClose={2000} />
          <div className="con1">
            <div className="cont">
              <div className="img-cont">
                <div>
                  <img src="../../images/rectangle.png" alt="int"></img>
                </div>
                <div className="con2">
                  <div className="link2-con">
                    <p className="link2">Eligibility</p>
                  </div>

                  <p>
                    An applicant may be eligible for the scholarship under the
                    following conditions:
                  </p>
                  <ul>
                    <li className="list">
                      Literacy: Applicant must be fluent in both written and
                      spoken English.
                    </li>
                    <li className="list">
                      Basic Computer Skill: Applicant must be able to operate a
                      computer and know the difference between a file and a
                      folder. Also have some familiarity with an office package
                      like MS Word or similar applications.
                    </li>
                    <li className="list">Tech savvy</li>
                    <li className="list">Ability to learn</li>
                  </ul>
                </div>
              </div>
              <div className="con3">
                <p className="link">Scholarship</p>
                <h2>Access Available Scholarship Programs</h2>
                <p className="body1">
                  Doyenify has a vast network of highly skilled software
                  developers and IT professionals with various expertise,
                  ensuring you can find the right talent for your specific
                  project needs.
                </p>
                <p>AVAILABLE MAY 21ST TO JUNE 17TH</p>
                <button
                  onClick={handleApplyNowClick}
                  disabled={isButtonDisabled}
                  className={isButtonDisabled ? "disabled-button" : ""}
                >
                  APPLY NOW
                </button>
              </div>
            </div>
            <h3 className="sec">Are You Interested? Apply Now</h3>
            <div className="con4" ref={applySectionRef}>
              <div className="img">
                <img src="../../images/rec.png" alt="int"></img>
              </div>
              <form
                onSubmit={handleSubmit(submitScholAppForm)}
                className="con5"
              >
                <div className="con6">
                  <div className="name-con con5-div">
                    <label htmlFor="fullname">Full Name</label>
                    <input
                      {...register("fullName")}
                      type="text"
                      className={
                        errors.fullName ? "form-control is-invalid" : ""
                      }
                      id="validationServer01"
                      value={inputName}
                      onChange={(e) => setInputName(e.target.value)}
                    />
                    {errors.fullName && (
                      <p className="errortext">{errors.fullName.message}</p>
                    )}
                  </div>
                  <div className="gender-con con5-div">
                    <label htmlFor="gender">Gender</label>
                    <select
                      {...register("gender")}
                      className={errors.gender ? "form-control is-invalid" : ""}
                      id="validationServer02"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                    {errors.gender && (
                      <p className="errortext">{errors.gender.message}</p>
                    )}
                  </div>
                </div>

                <div className="con5-div">
                  <label htmlFor="email">Email</label>
                  <input
                    {...register("email")}
                    type="email"
                    className={errors.email ? "form-control is-invalid" : ""}
                    id="validationServer03"
                    value={inputEmail}
                    onChange={(e) => setInputEmail(e.target.value)}
                  />

                  {errors.email && (
                    <p className="errortext">{errors.email.message}</p>
                  )}
                </div>
                <div className="con5-div">
                  <label htmlFor="phone">Phone number</label>
                  <div
                    style={{ width: "100%" }}
                    className={
                      nophoneerror
                        ? "textinputspwebinar"
                        : "textinputs2pwebinar"
                    }
                  >
                    <PhoneInput
                      inputStyle={{
                        width: "100%",
                        borderRadius: "20px",
                        borderColor: "#02813763",
                      }}
                      country={"ng"}
                      value={inputphone}
                      onChange={(inputphone) => setInputphone(inputphone)}
                      isValid={(value, country: any) => {
                        /* eslint-disable no-useless-escape */
                        if (
                          value.match(/^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/)
                        ) {
                          return (
                            "Invalid value: " + value + ", " + country.name
                          );
                          /* eslint-disable no-useless-escape */
                        } else if (
                          value.match(/^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/)
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      }}
                      inputProps={{
                        required: true,
                      }}
                    />
                  </div>
                  {nophoneerror ? (
                    <></>
                  ) : (
                    <>
                      <p className={nophoneerror ? "errortext3" : "errortext2"}>
                        something Wrong with the Phone Number
                      </p>
                    </>
                  )}
                </div>

                <div className="con5-div">
                  <select
                    {...register("course")}
                    className={errors.course ? "form-control is-invalid" : ""}
                    id="validationServer06"
                    value={course}
                    onChange={(e) => setCourse(e.target.value)}
                  >
                    <option value=" ">Choose Course</option>
                    <option value="DevOps">Devops</option>
                    <option value="HTML and CSS3 fundamentals">
                      HTML + CSS Fundamentals
                    </option>
                    <option value="Artificial Intelligence Fundamentals">
                      Artificial Intelligence Fundamentals
                    </option>
                    <option value="Graphics Design">Graphics Design</option>
                    <option value="WEB DESIGN">Web Design</option>
                    <option value="Network Security">Network Security</option>
                    <option value="Digital Marketing">Digital Marketing</option>
                    <option value="Python">Python</option>
                    <option value="Data Science">Data Science</option>
                    <option value="Mastering JavaScript Essentials">
                      Javascript Essentials
                    </option>
                    <option value="Business Intelligence">
                      Business Intelligence
                    </option>
                    <option value="C# for Beginners">C# for Beginners</option>
                    <option value="Automation Software Testing">
                      Software Testing
                    </option>
                    <option value="Financial Data Analytics">
                      Data Analytics
                    </option>
                    <option value="Search Engine Optimization (SEO)">
                      Search Engine Opt
                    </option>
                    <option value="UI/UX DESIGN">UI/UX Design</option>
                    <option value="IT Business Analysis">
                      Business Analysis
                    </option>
                    <option value="Data Analytics">Data Analytics</option>
                    <option value="Frontend Development">
                      Frontend Development
                    </option>
                    <option value="Mastering Github Essentials">
                      Github Essentials
                    </option>
                    <option value="Basics of SQL">Basics of SQL</option>
                    <option value="Elixir + Phoenix for Beginners">
                      Elixir + Phoenix
                    </option>
                    <option value="Full-stack Web Development with Python and Django">
                      Full Stack with Python + Django
                    </option>
                    <option value="Full-stack Web Development with node">
                      Full Stack with Node
                    </option>
                    <option value="Cybersecurity">Cybersecurity</option>
                    <option value="Data Engineering">Data Engineering</option>
                    <option value="Manual Software Testing">
                      Manual Software Testing
                    </option>
                    <option value="Mobile App Development">
                      Mobile App Development
                    </option>
                    <option value="Product Management">
                      Product Management
                    </option>
                  </select>
                  {errors.course && (
                    <p className="errortext">{errors.course.message}</p>
                  )}
                </div>
                <div className="con5-div">
                  <input
                    {...register("linkedIn")}
                    type="text"
                    className={errors.linkedIn ? "form-control is-invalid" : ""}
                    id="validationServer05"
                    placeholder="Enter your Linkedin url"
                    value={inputLinkedIn}
                    onChange={(e) => setInputLinkedIn(e.target.value)}
                  />

                  {errors.linkedIn && (
                    <p className="errortext">{errors.linkedIn.message}</p>
                  )}
                </div>
                <div className="pb-[15px] flex flex-col gap-2 lg:flex-row lg:gap-4 lg:items-center xl:flex-row xl:gap-4 xl:items-center ">
                  <label
                    htmlFor="coursePriceAffordability"
                    className="max-w-3xl"
                  >
                    How much of the course price can you afford (%)
                  </label>
                  <input
                    {...register("coursePriceAffordability", {
                      valueAsNumber: true,
                    })}
                    type="number"
                    className={
                      errors.coursePriceAffordability
                        ? "form-control is-invalid"
                        : ""
                    }
                    id="coursePriceAffordability"
                    value={inputCoursePriceAffordability}
                    onChange={handleCoursePriceAffordabilityChange}
                  />
                  {errors.coursePriceAffordability && (
                    <p className="errortext">
                      {errors.coursePriceAffordability.message}
                    </p>
                  )}
                </div>

                <div className="con5-div">
                  <label htmlFor="letter">Write your cover letter</label>
                  <textarea
                    rows={10}
                    {...register("coverLetter")}
                    className={
                      errors.coverLetter ? "form-control is-invalid" : ""
                    }
                    id="validationServer06"
                    value={inputCoverLetter}
                    onChange={(e) => setInputCoverLetter(e.target.value)}
                  ></textarea>
                  {errors.coverLetter && (
                    <p className="errortext">{errors.coverLetter.message}</p>
                  )}
                </div>

                <p>
                  Send your CV and cover letter to{" "}
                  <span className="cover">scholarships@doyenify.com</span>{" "}
                </p>
                <div className="button-con con5-div">
                  <button
                    type="submit"
                    disabled={isButtonDisabled}
                    className={isButtonDisabled ? "disabled-button" : ""}
                  >
                    Request for Scholarship
                  </button>
                </div>
              </form>
            </div>
          </div>

          <Footer />
        </>
      ) : (
        <>
          <div>
            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Scholarship;
